import React from "react";

interface SectionCardProps {
  title?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const SectionCard = ({ title, action, children, className = "" }: SectionCardProps) => {
  return (
    <section className={`drawCard ${className}`.trim()}>
      {title && (
        <header className="drawCardHeader">
          <h3 className="drawCardTitle">{title}</h3>
          {action}
        </header>
      )}
      {children}
    </section>
  );
};

export default SectionCard;
